/**
 * Calendar domain event schemas.
 *
 * Typed payload validation for all calendar-related Mycelium events.
 * Rule: fields added after initial release MUST be `.optional()`.
 *
 * @module calendar.events
 */

import { z } from 'zod'
import { BackboneEventSchema } from '../types/backbone.ts'

// ── Event schemas ───────────────────────────────────────────────────────

export const PrepTaskSuggestedEvent = BackboneEventSchema.extend({
  domain: z.literal('calendar'),
  type: z.literal('prep_task_suggested'),
  payload: z.object({
    eventId: z.string(),
    eventTitle: z.string(),
    eventDate: z.string(),
    suggestedTaskTitle: z.string(),
    suggestedDueDate: z.string().optional(),
    sourceEventId: z.string().optional(),
    source: z.string().optional(),
  }),
})

// ── Google Calendar push notification events ────────────────────────────

const GoogleCalendarWebhookPayload = z.object({
  channelId: z.string(),
  resourceId: z.string(),
  resourceState: z.enum(['sync', 'exists', 'not_exists', 'change']),
  resourceUri: z.string().optional(),
  channelExpiration: z.string().optional(),
  messageNumber: z.string().optional(),
  receivedAt: z.string(),
  source: z.string().optional(),
})

export const GoogleCalendarUpdatedEvent = BackboneEventSchema.extend({
  domain: z.literal('calendar'),
  type: z.literal('google_calendar_updated'),
  payload: GoogleCalendarWebhookPayload,
})

export const GoogleCalendarDeletedEvent = BackboneEventSchema.extend({
  domain: z.literal('calendar'),
  type: z.literal('google_calendar_deleted'),
  payload: GoogleCalendarWebhookPayload,
})

export const GoogleCalendarChangedEvent = BackboneEventSchema.extend({
  domain: z.literal('calendar'),
  type: z.literal('google_calendar_changed'),
  payload: GoogleCalendarWebhookPayload,
})

// ── All calendar events ─────────────────────────────────────────────────

export const CalendarDomainEvents = [
  PrepTaskSuggestedEvent,
  GoogleCalendarUpdatedEvent,
  GoogleCalendarDeletedEvent,
  GoogleCalendarChangedEvent,
] as const
